import { gsap } from 'gsap';

function halfGallerySetup(el) {
  const wrappers = [...el.querySelectorAll('.half-gallery__item')]
  const images = [...el.querySelectorAll('img')];

  gsap.set(images, { scale: 1.2 });
  gsap.set(wrappers, { autoAlpha: 0 });
}

function halfGalleryEnter(el) {
  const wrappers = [...el.querySelectorAll('.half-gallery__item')]
  const images = [...el.querySelectorAll('img')];

  const tl = gsap.timeline({ defaults: { duration: 1.2, ease: 'power2.out' }});
  tl.to(wrappers, { autoAlpha: 1 }, 0);
  tl.to(images, { scale: 1 }, 0);
}

export { halfGallerySetup, halfGalleryEnter };